module.exports = __webpack_public_path__ + "static/img/z8.962850c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/iot/z8.png
// module id = dSuy
// module chunks = 0